import service from '@api/config'

// 服务功能区-安卓
export const serviceFunctionsForAndroid = (data) => {
  return service.request({
    url: `/service/functions/android`,
    method: 'post',
    data: data
  })
}

// 服务功能区-ios
export const serviceFunctionsForIos = (data) => {
  return service.request({
    url: `/service/functions/ios`,
    method: 'post',
    data: data
  })
}

// 服务内容列表
export const serviceContents = (data) => {
  return service.request({
    url: `/service/contents`,
    method: 'post',
    data: data
  })
}

// 商家入驻
export const businessApply = (data) => {
  return service.request({
    url: `/service/business/apply`,
    method: 'post',
    data: data
  })
}

// 内容页面列表
export const listContent = (data) => {
  return service.request({
    url: `/service/pageInfo/list`,
    method: 'post',
    data: data
  })
}

// 内容页面列表
export const listContentMore = (data) => {
  return service.request({
    url: `/service/pageInfo/list/more`,
    method: 'post',
    data: data
  })
}

// 内容详情
export const detailContent = (id) => {
  return service.request({
    url: `/service/pageInfo/detail?contentId=` + id,
    method: 'post'
  })
}

// 文件下载顶部tabList
export const listFloor = (data) => {
  return service.request({
    url: `/service/pageInfo/floor/list`,
    method: 'post',
    data: data
  })
}

// 文件下载列表
export const listResource = (data) => {
  return service.request({
    url: `/service/pageInfo/resource/list`,
    method: 'post',
    data: data
  })
}

// 获取信息详情
export const infoDetail = (id) => {
  return service.request({
    url: `/service/pageInfo/detail?contentId=` + id,
    method: 'post'
  })
}

// 商家入驻
export const addCompany = (data) => {
  return service.request({
    url: `/service/business/apply`,
    method: 'post',
    data: data
  })
}

